module.exports = __webpack_public_path__ + "assets/img/map-zgwl.661b5064.svg";